import { NextCustomImage } from 'components/Image';
import type { MediaItem } from 'interfaces/content/Media';
import { parseCaptionWhenAltTextEmpty, parseContentForEmptySpace } from 'utils/parsingUtils/clientSideParsing';
import RawHtml from 'utils/miscUtils/rawHtml';
import * as S from './changeTheWorldItemStyles';

interface ChangeTheWorldItemProps {
  text: string;
  edition: string;
  image: MediaItem | null;
}

const ChangeTheWorldItem = ({ text, edition, image }: ChangeTheWorldItemProps) => (
  <S.Wrapper>
    <div>
      <span>{edition}</span>
      <div>{RawHtml({ html: parseContentForEmptySpace(text) })}</div>
    </div>

    {image && (
      <div>
        <NextCustomImage
          src={image.src || ''}
          alt={parseCaptionWhenAltTextEmpty(image)}
          width={975}
          height={650}
        />
        {image.credit && <span>{image.credit}</span>}
      </div>
    )}
  </S.Wrapper>
);

export default ChangeTheWorldItem;
